import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { BUILDING_CLASSES, BY_DEFAULT_DISTANCE, PROPERTY_TYPES, QUALATIVE_RATINGS, RATING_VALUES, SCHEMA_NAME, SUB_MARKET, UNDER_CONSTRUCTION } from 'src/app/shared/constants';
import { ZONING_OPTIONS } from '../../../shared/constants';
import { propertyTypes } from '../../property/property.model';
import { PropertyService } from 'src/app/services/property/property.service';

@Component({
  selector: 'app-custom-import-filters',
  templateUrl: './custom-import-filters.component.html',
  styleUrls: ['./custom-import-filters.component.scss']
})
export class CustomImportFiltersComponent {
  activePanel: string = '';

  submarkets = SUB_MARKET;
  propertyTypeForm!: FormGroup;
  landForm!: FormGroup;
  buildingForm!: FormGroup;
  saleDetailForm!: FormGroup;
  buildingClasses: any = BUILDING_CLASSES;
  qualitativeRatings: any = QUALATIVE_RATINGS;
  underConstructionStatus: any = UNDER_CONSTRUCTION;
  ratingValues: any = RATING_VALUES;
  zoningOptions: any = ZONING_OPTIONS;
  PROPERTY_TYPES = PROPERTY_TYPES;
  properties: any = [];
  @Input() columns: any = [];
  @Output() applyFilters = new EventEmitter<any>();
  @Output() selectedComps = new EventEmitter<any>();
  activeDropdown: string | null = null;
  mapCenter: any = {};
  searchText: string = '';
  sortOption: string = '';
  @Input() totalCount: number = 0;
  @Input() pageSize: number = 10;
  @Input() offset: number = 0;
  @Input() currentPage: number = 1;
  @Output() pageChange = new EventEmitter<number>();
  @Input() radius: number = 10000;
  @Input() onCellRender: Function;
  enableSummary: boolean = false;
  @Input() propertyDetail: any;
  enableAdjustment: boolean = false;
  locations: any = [];
  @ViewChild('scrollContainer', { static: true }) scrollContainer: ElementRef;
  @Output() loadMore = new EventEmitter<void>();
  propertyType: any[] = [];
  propertySubmarket: any[] = [];
  showMap = true;
  appliedFilters: any;
  @Input() schemaName: any;
  limit: number = 10;
  
  constructor(public fb: FormBuilder, private propertyService: PropertyService) { }

  ngOnInit() {
    this.buildingForm = this.createBuildingForm();
    this.landForm = this.createLandForm()
    this.saleDetailForm = this.createSaleDetailForm()
    this.propertyTypeForm = this.createPropertyTypeForm()
    this.locations = [{ lat: Number(this.propertyDetail?.latitude), lng: Number(this.propertyDetail?.longitude) }]
    const storedShowMap = localStorage.getItem('showMap');
    this.showMap = storedShowMap === null ? true : storedShowMap === 'true';
    this.getNearByComps({ radius: BY_DEFAULT_DISTANCE })
  }

  toggleMap(event) {
    this.showMap = event;
    localStorage.setItem('showMap', String(this.showMap));
  }

  createBuildingForm() {
    return this.fb.group({
      // units_min: [''],
      // units_max: [''],
      // stories_min: [''],
      // stories_max: [''],
      nra_min: [''],
      nra_max: [''],
      gba_min: [''],
      gba_max: [''],
      year_built_min: [''],
      year_built_max: [''],
      building_class: [''],
      qualitative_appeal: [[]],
      qualitative_building: [[]],
      qualitative_condition: [[]],
      qualitative_access: [[]],
      qualitative_exposure: [[]],
      qualitative_location: [[]],
      qualitative_site_utility: [[]],
      // under_construction: [ [] ], 

    });
  }


  createLandForm() {
    return this.fb.group({
      land_acres_min: [''],
      land_acres_max: [''],
      land_sqft_min: [''],
      land_sqft_max: [''],
      // qualitative_location: [[]],
      zoning: [''],
      // this.fb.array([]),
      corner_lot: [''],
      // hide_active_listing: [''] 
    });

  }

  createSaleDetailForm() {
    return this.fb.group({
      sale_date_start: new FormControl(null),
      sale_date_end: new FormControl(null),
      sale_price_min: new FormControl(null),
      sale_price_max: new FormControl(null),
      sale_price_psf_min: new FormControl(null),
      sale_price_psf_max: new FormControl(null),
      // pricePerUnitMin: new FormControl(null),
      // pricePerUnitMax: new FormControl(null),
      // pricePerLandSqftMin: new FormControl(null),
      // pricePerLandSqftMax: new FormControl(null),
      // pricePerLandAcresMin: new FormControl(null),
      // pricePerLandAcresMax: new FormControl(null),
      // radius: new FormControl(null),
      // qualitative_location: [[]],
      // rightTransferred: this.fb.control([]),
    });

  }


  createPropertyTypeForm() {
    return this.fb.group({
      categories: this.fb.array(PROPERTY_TYPES.map(category => this.createCategoryForm(category)))
    });

  }
  ngOnChange() {
  }
  toggleSelection(form: any, controlName: string, value: string) {
    const selectedItems = this.propertyTypeForm.get(controlName)?.value || [];

    if (selectedItems.includes(value)) {
      form.get(controlName)?.setValue(selectedItems.filter(item => item !== value));
    } else {
      form.get(controlName)?.setValue([...selectedItems, value]);
    }
  }

  toggleQualitiveRatingSelection(category: string, value: string) {
    const selectedValues = this.propertyTypeForm.value.qualitative_rating[category] || [];
    const updatedValues = selectedValues.includes(value)
      ? selectedValues.filter(item => item !== value)
      : [...selectedValues, value];
    this.propertyTypeForm.patchValue({
      qualitative_rating: {
        ...this.propertyTypeForm.value.qualitative_rating,
        [category]: updatedValues
      }
    });
  }



  get categoriesFormArray() {
    return this.propertyTypeForm.get('categories') as FormArray;
  }

  createCategoryForm(category: any): FormGroup {
    const categoryForm = this.fb.group({
      category: [false],
      subtypes: this.fb.array(category.subtypes ? category.subtypes.map(() => this.fb.control(false)) : [])
    });
    return categoryForm;
  }

  getSubtypesControls(index: number) {
    return (this.categoriesFormArray.at(index).get('subtypes') as FormArray).controls;
  }


  resetFilters() {
    this.propertyTypeForm.reset();
    this.saleDetailForm.reset();
    this.landForm.reset();
    this.buildingForm.reset();
    this.radius = BY_DEFAULT_DISTANCE;
    this.activeDropdown = ''
    this.propertyType = [];
    this.propertySubmarket = [];
    this.applyFilters.emit({ radius: BY_DEFAULT_DISTANCE })
  }

  toggleDropdown(type: string) {
    this.activeDropdown = this.activeDropdown === type ? null : type;
  }

  closeDropdown() {
    this.activeDropdown = null;
  }

  selectAll = false;

  dropdownStates: { [key: string]: boolean } = {};

  toggleDropdown1(category: string) {
    this.dropdownStates[category] = !this.dropdownStates[category];
  }

  submitFilter() {
    const raw = {
      ...this.saleDetailForm.value,
      ...this.buildingForm.value,
      ...this.landForm.value,
    };

    const filteredObject: Record<string, any> = {};

    Object.entries(raw).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        const validValues = value.filter(v => v !== null && v !== undefined && v !== '');
        if (validValues.length) {
          filteredObject[key] = validValues;
        }
      } else if (value !== null && value !== undefined && value !== '') {
        filteredObject[key] = value;
      }
    });

    if (this.radius) {
      filteredObject['radius'] = this.radius.toString();
    }

    if (this.propertyType.length) {
      filteredObject['propertyType'] = this.propertyType
    }

    if (this.propertySubmarket.length) {
      filteredObject['propertySubmarket'] = this.propertySubmarket
    }

    this.appliedFilters = filteredObject
    this.getNearByComps(this.appliedFilters)

    this.activeDropdown = '';
  }

  @Input() selectedProperties: any = [];

  onSelectionChange(event: boolean, property: any) {
    if (event) {
      this.selectedProperties.push(property);
    } else {
      this.selectedProperties = this.selectedProperties.filter(p => {
        return !Object.keys(property).every(key => p[key] === property[key]);
      });      
    }


    this.locations = this.selectedProperties
      .filter(p => p.lat && p.lng)
      .map(p => ({
        lat: Number(p.lat),
        lng: Number(p.lng)
      }));

    this.locations.unshift({ lat: Number(this.propertyDetail.latitude), lng: Number(this.propertyDetail.longitude) })
  }

  isSelected(property: any): boolean {
    return this.selectedProperties?.some(p =>
      Object.keys(property).every(key => p[key] === property[key])
    );
  }  


  // currentPage = 1;

  onPageChanged(newPage: number) {
    this.currentPage = newPage;
    this.offset = ((this.currentPage-1)*10)+1
    this.getNearByComps(this.appliedFilters)
    this.selectAll=false;
  }


  getDisplayValue(row: any, col: any): string {
    const value = row[col.field];
    switch (col.unit) {
      case 'percentage':
        return (value != null ? value.toFixed(2) + '%' : '0%');

      case 'currency':
        return this.formatCurrency(value); // use your existing method

      case 'time':
        return (value != null ? value.toFixed(2) + 'ms' : '0ms');

      case 'number':
        return this.formatNumber(value); // use your existing method

      case 'date':
        return value ? new Date(value).toLocaleDateString('en-US') : 'NA';

      case 'distance':
        return value != null ? value.toFixed(2) + ' ' + (row[col.unit] || '') : '0';

      case 'custom':
        // optional - return '' here and handle rendering separately with renderCell()
        return '';

      default:
        return value != null ? value : 'NA';
    }
  }


  formatCurrency(value: number, locale: string = 'en-US', currency: string = 'USD'): string {
    return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(value && !isNaN(value) ? value : 0);
  }


  formatNumber(value: number, locale: string = 'en-US'): string {
    return new Intl.NumberFormat(locale).format(value);
  }

  renderCell(data) {
    return this.onCellRender(data);
  }


  toggleQualitiveSelection(form, formControl: string, item: string) {
    const selectedItems = form.value[formControl] || [];
    const index = selectedItems.indexOf(item);

    if (index > -1) {
      selectedItems.splice(index, 1);
    } else {
      selectedItems.push(item);
    }

    form.patchValue({ formControl: selectedItems })
  }

  private lastScrollTop = 0;
  private loadingMore = false;

  onScroll(event: Event) {
    const element = event.target as HTMLElement;

    const currentScrollTop = element.scrollTop;
    const scrollingDown = currentScrollTop > this.lastScrollTop;
    this.lastScrollTop = currentScrollTop;

    const scrollPosition = currentScrollTop + element.clientHeight;
    const threshold = element.scrollHeight - 100;

    if (scrollingDown && scrollPosition >= threshold && !this.loadingMore) {
      this.loadingMore = true;
      this.fetchMoreData()

      setTimeout(() => {
        this.loadingMore = false;
      }, 500);
    }
  }



  togglePropertyType(value: string): void {
    const index = this.propertyType.indexOf(value);
    if (index > -1) {
      this.propertyType.splice(index, 1);
    } else {
      this.propertyType.push(value);
    }

  }

  toggleSubmarket(value: string): void {
    const index = this.propertySubmarket.indexOf(value);
    if (index > -1) {
      this.propertySubmarket.splice(index, 1);
    } else {
      this.propertySubmarket.push(value);
    }
  }

  selectAllProerties(event) {
    if (event) {
      this.selectedProperties = this.properties;
    }
    else {
      this.selectedProperties = []
    }


    this.locations = this.selectedProperties
      .filter(p => p.lat && p.lng)
      .map(p => ({
        lat: Number(p.lat),
        lng: Number(p.lng)
      }));

    this.locations.unshift({ lat: Number(this.propertyDetail.latitude), lng: Number(this.propertyDetail.longitude) })
  }




  async getNearByComps(data, type?: any) {
    this.appliedFilters = data;
    let obj: any = {}
    const params: any = new URLSearchParams();
    obj = { ...data, lat: this.propertyDetail.latitude, lng: this.propertyDetail.longitude, limit: this.limit, offset:this.offset }
    Object.entries(obj).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach(val => {
          params.append(key, val);
        });
      } else {
        params.append(key, value);
      }
    });

    const queryString = params.toString();
    const compType=this.schemaName===SCHEMA_NAME.COMP_SALES_HISTORY ? 'sales-history' :'lease'
    this.propertyService.getCompData(`${compType}/search`, queryString).subscribe((res) => {
      this.properties = res.results|| [];
      this.totalCount = res?.totalCount || 0;
    })
  }


  fetchMoreData() {
    this.offset += 10;
    this.getNearByComps(this.appliedFilters, 'add');
    this.selectAll=false;
  }
}

